import React from "react";
import GetToday from "../../utils/GetToday";
import Time from "./Time";
import Placeholder from "./Download";
export default function ReceiptLayout({
  name,
  address,
  city,
  priceSymbol,
  taxFields,
  itemFields,
  fontFamily,
  tankYouNote,
  checked,
  businessLogo,
}) {
  const getTotalTaxParcent = () => {
    return taxFields.reduce((total, item) => {
      return total + Number(item.taxPercent);
    }, 0);
  };
  const getTotalItemCosts = () => {
    return itemFields.reduce((total, item) => {
      return total + Number(item.qty) * Number(item.price);
    }, 0);
  };

  return (
    <>
      <div className="flex justify-center">
        <div className="shadow-lg">
          <div
            id="capture"
            className="receipt-container bg-white px-6 py-8 select-none"
            style={{ width: "350px", fontFamily: `${fontFamily}` }}
          >
            {!checked ? (
              <div className="business-name text-center font-bold text-4xl ">
                {name}
              </div>
            ) : (
              <div className="business-logo flex justify-center">
                <div className="w-56 p-2 mb-4">
                  <img
                    className="w-full"
                    src={businessLogo}
                    alt="Business Logo"
                  />
                </div>
              </div>
            )}
            <div className="address text-center">
              <p>{address}</p>
              <p>{city}</p>
            </div>
            <div className="date-time flex justify-between font-semibold border-t-2 border-b-2 border-gray-700 my-4 py-3">
              <div className="date w-1/2">Date: {GetToday()}</div>
              <div className="w-1/2 text-right">
                <Time />
              </div>
            </div>
            <div className="item-list py-2">
              {itemFields.length
                ? itemFields.map((item) => {
                    const p = Number(item.price) || 0;
                    const q = Number(item.qty) || 1;
                    return (
                      <div key={item.id} className="item mb-2">
                        <div className="description">
                          {item.description
                            ? item.description
                            : "No description provided"}
                        </div>
                        <div className="flex justify-between items-center">
                          <div className="item-i text-sm">
                            {item.qty ? item.qty : 1}x
                            {item.price ? item.price : 0}
                          </div>
                          <div className="w-full px-4">
                            <div className="border-t border-gray-600"></div>
                          </div>
                          <div className="price">{(p * q).toFixed(2)}</div>
                        </div>
                      </div>
                    );
                  })
                : "No item found"}
            </div>
            {itemFields.length && taxFields.length ? (
              <div className="flex justify-end">
                <div className="total w-16 text-right font-semibold border-t border-gray-700 inline-block">
                  {getTotalItemCosts().toFixed(2)}
                </div>
              </div>
            ) : null}
            <div
              className={`vat font-semibold ${
                taxFields.length
                  ? "border-t-2 border-b-2 my-4 py-3"
                  : "border-b-2 mt-4 "
              } border-gray-700 `}
            >
              {taxFields.length
                ? taxFields.map((taxField, index) => {
                    const p = Number(taxField.taxPercent) || 0;
                    return (
                      <div key={index} className="flex justify-between mb-1">
                        <div className="vat-percent uppercase">
                          {taxField.taxType ? taxField.taxType : "undefined"}
                          <span className="ml-1">
                            {taxField.taxPercent ? taxField.taxPercent : "0"}%
                          </span>
                        </div>
                        <div>
                          {((p / 100) * getTotalItemCosts()).toFixed(2)}
                        </div>
                      </div>
                    );
                  })
                : ""}
            </div>
            <div className="total flex font-semibold my-4">
              <div className="total w-1/2">TOTAL</div>
              <div className="total-amount uppercase w-1/2 text-right">
                {priceSymbol}{" "}
                {(
                  getTotalItemCosts() +
                  (getTotalTaxParcent() / 100) * getTotalItemCosts()
                ).toFixed(2)}
              </div>
            </div>
            <div className="note text-center text-sm mt-4">{tankYouNote}</div>
          </div>
        </div>
      </div>
      <div className="download mt-8 flex flex-wrap justify-center">
        <button
          id="download-png"
          className="bg-purple-600 py-2 px-8 rounded text-white m-2"
          onClick={() => Placeholder()}
          aria-label="download your receipt"
        >
          <i className="demo-icon icon-download mr-1 text-lg"></i>
          Download Receipt
        </button>
      </div>
    </>
  );
}
